
import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const Aside = ({ navLi }) => {
    return (
        <>
            <aside id="sidebar" className="sidebar">
        
                <ul className="sidebar-nav" id="sidebar-nav">

                    {
                        navLi.map(({key,label,uri})=>{
                            return (
                                <li key={key} className="nav-item">
                                    <NavLink className="nav-link " to={uri}>
                                        <i className="bi bi-grid"></i>
                                        <span>{label}</span>
                                    </NavLink>
                                </li>
                            )
                        })
                    }
            
                </ul>
        
            </aside>
        </>
    )
}

Aside.propTypes = {
    navLi: PropTypes.array
}

export default Aside;